/* Redux-Toolkit */
import { createAsyncThunk } from "@reduxjs/toolkit";

/* Axios */
import axiosInterceptor from "src/utils/helper/axios-interceptor";

/* Utils */
import { createCookies } from "src/utils/helper/cookies";
import { ClientError } from "src/utils/status-handling/ClientError";

/* Interfaces */
import { AuthProps } from "src/shared/interfaces/common/Auth";

export const refreshAccessToken = createAsyncThunk<
  AuthProps,
  void,
  { rejectValue: ClientError }
>("refreshToken", async (_, { rejectWithValue }) => {
  try {
    const response = await axiosInterceptor.get(
      "/refresh_token"
    );
    return createCookies(response);
  } catch (error) {
    return rejectWithValue(ClientError.unexpected());
  }
});
